import { __assign, __read, __spreadArray } from "tslib";
import update from 'immutability-helper';
import { useMutation } from 'react-apollo';
import { showErrorNotification } from '../../ToastContainer';
import { GET_GROUP_MEMBERS, REMOVE_MEMBERS_FROM_TEAM } from '../graphql';
var toastId = 'removeMembers';
export default function useRemoveMembersFromTeamMutation() {
    var _a = __read(useMutation(REMOVE_MEMBERS_FROM_TEAM)), removeCollaborators = _a[0], rest = _a.slice(1);
    return __spreadArray([
        function (_a) {
            var teamPk = _a.teamPk, emails = _a.emails;
            removeCollaborators({
                variables: {
                    teamPk: teamPk,
                    emails: emails,
                },
                update: function (cache, response) {
                    var removedEmails = response.data.removeMembersFromTeam.succeeded;
                    cacheRemoveMembersFromTeam(cache, {
                        teamPk: teamPk,
                        emails: removedEmails,
                    });
                },
                optimisticResponse: {
                    removeMembersFromTeam: {
                        __typename: 'RemoveMembersFromTeam',
                        succeeded: emails,
                        failed: [],
                    },
                },
            })
                .then(function (_a) {
                var data = _a.data;
                var failed = data.removeMembersFromTeam.failed;
                if (failed.length) {
                    var errorMessage = failed.length > 1
                        ? "There was an issue trying to remove ".concat(failed.length, " users from this group. Please try again later")
                        : "There was an issue trying to remove ".concat(failed[0].email, " from this group. Please try again later");
                    showErrorNotification({
                        toastId: toastId,
                        content: errorMessage,
                    });
                }
            })
                .catch(function () {
                showErrorNotification({
                    toastId: toastId,
                    content: 'Oops, something went wrong. Try again later',
                });
            });
        }
    ], __read(rest), false);
}
export function cacheRemoveMembersFromTeam(cache, _a) {
    var teamPk = _a.teamPk, emails = _a.emails;
    var queryProps = {
        query: GET_GROUP_MEMBERS,
        variables: { teamPk: teamPk },
    };
    var data = cache.readQuery(queryProps);
    var updatedData = update(data, {
        team: {
            members: {
                edges: function (edges) {
                    return edges.filter(function (memberEdge) { return emails.indexOf(memberEdge.node.email) === -1; });
                },
            },
        },
    });
    cache.writeQuery(__assign(__assign({}, queryProps), { data: updatedData }));
}
